import {makeAutoObservable, toJS} from "mobx";

/**
 * HistoryState is the client interface to to HistoryStateManager.
 * It encapsulates a single value that is created in the constructor
 * and can be read and written.
 */
export class HistoryState<T extends { [key: string]: any }> {
	private state: T;

	constructor(initialValues: T) {
		makeAutoObservable(this);
		this.state = initialValues;
		this.replace(initialValues);

		// subscribe to popstate event
		window.addEventListener("popstate", this.handlePopState);
	}

	private handlePopState = (event: PopStateEvent) => {
		if (event.state) {
			console.debug("HistoryState.handlePopState", event.state);
			this.state = event.state as T;
		}
	};

	get current() {
		return this.state;
	}

	push(newState: Partial<T>) {
		this.state = {...this.state, ...newState};
		const snapshot = toJS(this.state);
		console.debug("HistoryState.push: ", snapshot);
		history.pushState(snapshot, "");
	}

	replace(newState: Partial<T>) {
		this.state = {...this.state, ...newState};
		const snapshot = toJS(this.state);
		console.debug("HistoryState.replace: ", snapshot);
		history.replaceState(snapshot, "");
	}
}
